module.exports = __webpack_public_path__ + "img/6.32c87c3d.jpg";